<template>
    <div class="distribution-sort ">
        <div class="module-item-style">
            <div class="module-item-title">客服排序设置</div>
            <div class="setting-distribution-tips">上下拖动可调整客服排序, 此排序对各种依赖排序的分配规则都有效</div>
            <div class="sort-service-container">
                <div class="table-title">
                    <div class="servic-no">客服排序</div>
                    <div class="sort-time">
						工作时段
						<el-popover
						  placement="right"
						  width="400"
						  style="margin-left: 5px;vertical-align: middle;"
						  trigger="hover"
						>
						  <span style="font-size: 12px;color: #333;"
						    >当开始时间小于结束时间时，例如：（09：00-18：00），工作时段为09：00-18：00;
当开始时间大于结束时间时，例如：（18：00-09：00），工作时段为18：00-23：59  和  00：00-9：00</span
						  >
						  <span slot="reference"><i class="el-icon-info"></i></span>
						</el-popover>
					</div>
                    <div class="rule-operate">不参与分配规则</div>
                </div>
                <draggable v-model="serviceList" @start="drag=true" @end="onEnd">
                    <div class="sort-service-item-wrap" v-for="(item, i) in serviceList" :key="item.id">
                        <div class="sort-service-item servic-no">
                            <div class="sort-num">#<el-input v-model="item.sortRole" @input="sortInput(item)" @blur="sortChange(item)" @keyup.enter.native="sortChange(item)" type="number"></el-input></div>
                            <div class="sort-service-avatar">
                                <img :src="avatarX(item.headImg)" alt="图片">
                            </div>
                            <div class="sort-service-name" :title="item.name">{{item.name}}</div>
                        </div>
                        <div class="sort-time" style="min-height: 73px;">
							<el-time-picker
								format="HH:mm"
								v-model="item.openTime">
							</el-time-picker>
							-
							<el-time-picker
								format="HH:mm"
								v-model="item.closeTime">
							</el-time-picker>
							<el-select
							    v-model="item.workWeek"
							    multiple
							    collapse-tags
							    style="margin-left: 20px;width: 160px;"
							    placeholder="请选择工作日" 
								@change="sortWorkWeek(item)" 
								@remove-tag="sortWorkWeek(item)">
							    <el-option
							      v-for="week in workWeekArr"
							      :key="week.value"
							      :label="week.label"
							      :value="week.value">
							    </el-option>
							  </el-select>
							<div class="wl-btn" @click="saveServiceTime(item)">确定</div>
                        </div>
                        <div class="rule-operate">
                            <el-checkbox @change="saveServiceRule(item)" v-model="item.isAssign">不参与分配规则</el-checkbox>
                        </div>
                    </div>

                </draggable>

            </div>
        </div>


        <!-- <div class="distribution-operation-container module-item-style" :class="!isCollapse ? 'to210' : 'to64'">
            <span class="wl-btn" @click="saveServiceSort">保存</span>
            <span class="wl-btn-cancel" @click="handlerCancel">取消</span>
        </div> -->
    </div>
</template>

<script>
    import draggable from 'vuedraggable'

    import avatar0 from '@/assets/images/client_avatar_empty.png'
    import avatar1 from '@/assets/images/client_avatar1.png'
    import avatar2 from '@/assets/images/client_avatar2.png'
    import avatar3 from '@/assets/images/client_avatar3.png'
    import avatar4 from '@/assets/images/client_avatar4.png'
    import avatar5 from '@/assets/images/client_avatar5.png'
    import avatar6 from '@/assets/images/client_avatar6.png'
    import avatar7 from '@/assets/images/client_avatar7.png'

    export default {
        name: 'distribution-sort',
        components: {
            draggable
        },
        data() {
            return {
                currentDateStartTimestamp: new Date(new Date().toLocaleDateString()).getTime(),
                currentDateEndTimestamp: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 60,
                serviceList: [],
                sortList: [],
                timeSelect: {},
                timePickerShake: true,
				workWeekArr: [{
				  value: 1,
				  label: '星期一'
				}, {
				  value: 2,
				  label: '星期二'
				}, {
				  value: 3,
				  label: '星期三'
				}, {
				  value: 4,
				  label: '星期四'
				}, {
				  value: 5,
				  label: '星期五'
				}, {
				  value: 6,
				  label: '星期六'
				}, {
				  value: 7,
				  label: '星期日'
				}]
            }
        },
        computed: {
            isCollapse() {
                return this.$store.state.app.sidebar.clapse
            },
        },
        watch: {
            serviceList(val) {
                console.log('val==', val)
            }
        },
        created() {
            this.getServiceSort()
        },
        mounted() {

        },
        methods: {
			sortInput(item){
				item.sortRole = item.sortRole.replace(/[^\d]/g, "").trim()
				if(item.sortRole*1>this.serviceList.length*1){
					item.sortRole = this.serviceList.length
				}
				if(item.sortRole<0){
					item.sortRole = 1
				}
			},
			sortWorkWeek(item) {
				item.workWeek.sort()
			},
            avatarX(avatar) {
                const img = avatar.substring(avatar.length - 5, avatar.length - 4)
                switch (img) {
                    case 'y':
                        return avatar0
                        break
                    case '1':
                        return avatar1
                        break
                    case '2':
                        return avatar2
                        break
                    case '3':
                        return avatar3
                        break
                    case '4':
                        return avatar4
                        break
                    case '5':
                        return avatar5
                        break
                    case '6':
                        return avatar6
                        break
                    case '7':
                        return avatar7
                        break
                    default:
                        return avatar
                        break
                }
            },
            getServiceSort() {
                this.$http.getServiceSortAPI().then(res => {
                    if (res.status == 1) {
                        this.serviceList = res.data
                        this.sortList = []
                        this.serviceList.map((item, index) => {
						  // 工作日为null 则说明默认全选
						  if(item.workWeek == null){
							item.workWeek = [1,2,3,4,5,6,7]
						  } else {
							  let workWeek = item.workWeek.split(',')
							  item.workWeek = []
							  workWeek.forEach(day => {
								  item.workWeek.push(day*1) // 类型必须和select的绑定类型一致	
							  })
						  }
						  item.workWeek.sort()
						  // 定义一个最初始的排序号
						  item.oldSort = item.sortRole
                          // 获取当前日期
                          let date = new Date();
                          // 获取当前月份
                          let nowMonth = date.getMonth() + 1;
                          // 获取当前是几号
                          let strDate = date.getDate();
                          // 添加分隔符“-”
                          let seperator = "-";
                          // 对月份进行处理，1-9月在前面添加一个“0”
                          if (nowMonth >= 1 && nowMonth <= 9) {
                            nowMonth = "0" + nowMonth;
                          }
                          // 对月份进行处理，1-9号在前面添加一个“0”
                          if (strDate >= 0 && strDate <= 9) {
                            strDate = "0" + strDate;
                          }
                          // 最后拼接字符串，得到一个格式为(yyyy-MM-dd)的日期
                          let nowDate = date.getFullYear() + seperator + nowMonth + seperator + strDate;
                          let openTimeStr = nowDate + ' ' + item.openTime
                          let closeTimeStr = nowDate + ' ' + item.closeTime
                          if (item.openTime) {
							 item.openTime = new Date(openTimeStr)
							 item.closeTime = new Date(closeTimeStr)
                            //item.serviceSwitchTime = [new Date(openTimeStr), new Date(closeTimeStr)]
                          } else {
                            //item.serviceSwitchTime = [this.currentDateStartTimestamp, this.currentDateEndTimestamp]
							item.openTime = this.currentDateStartTimestamp
							item.closeTime = this.currentDateEndTimestamp
                          }
                          if(item.isAssign == 1){
                            item.isAssign = false
                          } else if (item.isAssign == 0) {
                            item.isAssign = true
                          } else {
                              item.isAssign = false
                          }
                            this.timeSelect[index] = item.serviceSwitchTime
                            let srotInit = {
                                csId: '',
                                sortRole: ''
                            }
                            srotInit.csId = item.id
                            srotInit.sortRole = item.sortRole
                            this.sortList.push(srotInit)
                        })
						console.log(this.serviceList)
                    }
                })
            },
            onEnd(e) {
                let newIndex = e.newIndex
                let oldIndex = e.oldIndex
                if (oldIndex > newIndex) {
                    // 向上拖
                    this.sortList.splice(newIndex, 0, this.sortList[oldIndex]);
                    this.sortList.splice(oldIndex + 1, 1)
                } else {
                    // 向下拖
                    this.sortList.splice(newIndex + 1, 0, this.sortList[oldIndex]);
                    this.sortList.splice(oldIndex, 1)
                }
                this.sortList.map((item, i) => {
                    item.sortRole = i + 1
                })
				this.saveServiceSort()
            },
			sortChange(item){
				if(!item.sortRole){
					this.$message.error("请输入有效的数字")
					return false
				}
				let newIndex = item.sortRole*1 - 1
				let oldIndex = item.oldSort*1 - 1
				if(oldIndex==newIndex){
					return false
				}
				if (oldIndex > newIndex) {
				    // 向上拖
				    this.sortList.splice(newIndex, 0, this.sortList[oldIndex]);
				    this.sortList.splice(oldIndex + 1, 1)
				} else {
				    // 向下拖
				    this.sortList.splice(newIndex + 1, 0, this.sortList[oldIndex]);
				    this.sortList.splice(oldIndex, 1)
				}
				
				this.sortList.map((item, i) => {
				    item.sortRole = i + 1
				})
				this.saveServiceSort()
			},
            saveServiceTime(item){
			  if(!item.workWeek.length){
				  this.$message.warning('请至少选择一天工作时段')
				  return false
			  }
              let params = {
                csId: item.id,
                openTime: this.$utils.timestampToTime(item.openTime / 1000).split(' ')[1],
                closeTime: this.$utils.timestampToTime((item.closeTime / 1000)).split(' ')[1],
				workWeek: item.workWeek.join(',')
              }
              this.$http.saveServiceTimeAPI(params).then(res => {
                if (res.status) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                    })
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                    })
                }
              })
            },
            saveServiceRule(item){
              let isAssign = 1
              if(item.isAssign || item.isAssign == 'true'){
                isAssign = 0
              } else {
                isAssign = 1
              }
              let params = {
                csId : item.id,
                isAssign: isAssign
              }
              this.$http.saveServiceSortRulesAPI(params).then( res => {
                if (res.status) {
                  this.$message({
                    message: res.msg,
                    type: 'success',
                  })
                } else {
                  this.$message({
                    message: res.msg,
                    type: 'error',
                  })
                }
              })
            },
            saveServiceSort() {
                let listData = this.sortList
                listData.map((item, i) => {
                    item.sortRole = i + 1
                })
                this.$http.saveServiceSortAPI({
                    list: listData
                }).then(res => {
                    if (res.status) {
                        this.getServiceSort()
                        this.$message({
                            message: res.msg,
                            type: 'success',
                        })
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        })
                    }
                })

            },
            handlerCancel() {
                this.$router.push({
                    path: '/setting-online-distribution-setting'
                })
            }
        }
    }
</script>

<style lang="scss">
    .distribution-sort {
        $tableBorderColor: #ccc;

        .sort-service-container {
            padding: 0;
            margin-top: 10px;
            border: 1px solid $tableBorderColor;
            box-sizing: border-box;
            width: 100%;

            .servic-no {
                width: 0;
                flex: 1;
            }

            .sort-time {
                width: 550px;
                border-left: 1px solid $tableBorderColor;
                border-right: 1px solid $tableBorderColor;
            }
			.wl-btn{
				margin-left: 15px;
			}
            .rule-operate {
                width: 170px;
                text-align: center;
            }

            .table-title {
                display: flex;
                line-height: 32px;

                & > div {
                    font-size: 14px;
                    color: #333;
                    padding: 10px 0;
                    font-weight: bold;
                    text-align: center;
                }
            }

            .sort-service-item-wrap {
                display: flex;
                line-height: 32px;
              cursor: move;

                & > div {
                    padding: 15px;
                    border-top: 1px solid $tableBorderColor;
                }
            }

            .sort-service-item {
                display: flex;
                color: #333;

                .sort-num {
                    width: 60px;
					.el-input{
						width: 40px;
						margin-left: 5px;
					}
					.el-input__inner{
						padding: 0 5px;
					}
					/* 谷歌 */
					input::-webkit-outer-spin-button,
					input::-webkit-inner-spin-button {
					    -webkit-appearance: none;
					    appearance: none; 
					    margin: 0; 
					}
					/* 火狐 */
					input{
					    -moz-appearance:textfield;
					}
                }

                .sort-service-name {
                    flex: 1;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .sort-service-avatar {
                    width: 50px;
                    text-align: center;

                    img {
                        display: block;
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        overflow: hidden;
                    }
                }
            }

            .sort-service-item + .sort-service-item {
                margin-top: 20px;
            }
        }

        .distribution-operation-container {
            text-align: center;
            position: fixed;
            bottom: 0;
            right: 0;
            z-index: 999;
            border-radius: 0;

            &.to210 {
                left: 210px;
            }

            &.to64 {
                left: 64px;
            }

            span + span {
                margin-left: 15px;
            }
        }
		.el-date-editor.el-input, .el-date-editor.el-input__inner{
			width: 120px!important;
		}
    }
	
</style>
